import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SendRecoveryMailResponse extends BackendResponse {}

export interface SendRecoveryMailParameters extends NextApiParams {
  email: string;
  concernId: number;
  evaluatedLocale: string;
}

export const sendAttachProfileEmail = withNextApi<
  SendRecoveryMailResponse,
  SendRecoveryMailParameters
>("/auth/SendAttachProfileEmail");
